module.exports = __webpack_public_path__ + "img/why-icon-4.d43d68b4.svg";